// removed by extract-text-webpack-plugin
module.exports = {"searchInputCancelButton":"styles__searchInputCancelButton___dhWHs"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/searchInputCancelButton/styles.css
// module id = yj6G
// module chunks = 2